import React from 'react';
import WordPressForm from './WordPressForm';
import WebflowForm from './WebflowForm';
import NotionForm from './NotionForm';
import ShopifyForm from './ShopifyForm';
import WixForm from './WixForm';
import WordPressComForm from './WordPressComForm';
import ApiWebhookForm from './ApiWebhookForm';

const IntegrationForm = ({ integrationType, formData, setFormData, isSubmitting, handleCreateIntegration }) => {
  switch (integrationType) {
    case 'wordpress':
      return <WordPressForm formData={formData} setFormData={setFormData} isSubmitting={isSubmitting} handleCreateIntegration={handleCreateIntegration} />;
    case 'notion':
      return <NotionForm formData={formData} setFormData={setFormData} isSubmitting={isSubmitting} handleCreateIntegration={handleCreateIntegration} />;
    case 'webflow':
      return <WebflowForm formData={formData} setFormData={setFormData} isSubmitting={isSubmitting} handleCreateIntegration={handleCreateIntegration} />;
    case 'shopify':
      return <ShopifyForm formData={formData} setFormData={setFormData} isSubmitting={isSubmitting} handleCreateIntegration={handleCreateIntegration} />;
    case 'wix':
      return <WixForm formData={formData} setFormData={setFormData} isSubmitting={isSubmitting} handleCreateIntegration={handleCreateIntegration} />;
    case 'wordpress-com':
      return <WordPressComForm />;
    case 'api-webhook':
      return <ApiWebhookForm formData={formData} setFormData={setFormData} />;
    default:
      return (
        <div className="text-center py-8">
          <p>Please select an integration type to configure.</p>
        </div>
      );
  }
};

export default IntegrationForm;

